<template>
  <div class="conteudoInterno" id="numeros2022">
    <div class="boxSeta">
      <div
        class="setaScrollstatic"
        style=""
        :class="{
          setaScroll: setaScrollState,
        }"
      >
        <button>
          <span><i class="bottom"></i></span>
        </button>
      </div>
    </div>
    <header class="headerSec">
      <h2>Os números da UBC em 2025</h2>
      <div class="navSetas">
        <button @click="goBack()" :disabled="clicked">
          <span><i class="left"></i></span>
        </button>
        <button @click="goNext()" :disabled="clicked">
          <span><i class="right"></i></span>
        </button>
      </div>
    </header>
    <div class="conteudoInternoBox" ref="infoBox">
      <section class="sectionRow" ref="infoscroll">
        <div class="col23ponto5 marginColBottom">
          <span class="linecol ubcRedBack"></span>
        </div>
        <div class="col49 top32">
          <p>
            Aqui focamos os números da UBC, que são o resultado direto dos
            nossos esforços em documentação, liberação de execuções previamente
            não identificadas, serviços aos associados e processos internos de
            distribuição de royalties recebidos do exterior, bem como direitos
            fonomecânicos. Além, claro, da nossa participação nos dados de
            execução no território nacional, detalhados anteriormente.
          </p>
          <p>
            A UBC respondeu por 62% de tudo o que foi distribuído pelo conjunto
            das sociedades que compõem o Ecad.
          </p>
        </div>
      </section>
      <section class="sectionRow top80">
        <div class="col40ponto4 ubcRedBack"></div>
        <div class="col49">
          <div class="col100">
            <h4 class="h4Destaque ubcRed sanukBlack">
              Números de distribuição da UBC
            </h4>
          </div>
          <div class="col100 spaceBetween top50">
            <div class="col49sub">
              <h3>Direitos de execução pública (arrecadados no Brasil)</h3>
              <div class="numerosBox">
                <p>Total:</p>
                <span class="ubcRed sanukBlack">R$ 987.822.510</span>
              </div>
            </div>
            <div class="col49sub topMob32">
              <h3>Direitos de execução pública (Arrecadados no Exterior)</h3>
              <div class="numerosBox">
                <p>Total:</p>
                <span class="ubcRed sanukBlack">R$ 12.893.997</span>
              </div>
            </div>
          </div>
          <div class="col100 spaceBetween top32">
            <div class="col49sub">
              <h3>Direitos de Reprodução Mecânicos (nacional)</h3>
              <div class="numerosBox">
                <span class="ubcRed sanukBlack">R$ 5.146.694</span>
              </div>
            </div>
            <div class="col49sub topMob32">
              <h3>Direitos de Reprodução Mecânicos (internacional)</h3>
              <div class="numerosBox">
                <span class="ubcRed sanukBlack">R$ 44.408</span>
              </div>
            </div>
          </div>
          <div class="col100 top80">
            <h3>Quantidade de titulares contemplados</h3>
            <!-- <p>A UBC pagou royalties para:</p> -->
          </div>
          <div class="col100 spaceBetween top32">
            <div class="col49sub">
              <span class="titleDireitos sanukBold">Estrangeiro</span>
              <div class="numerosBox">
                <span class="ubcRed sanukBlack">206.174</span>
                <!-- <p>compositores/autores</p> -->
              </div>
              <!-- <div class="numerosBox">
                <span class="ubcRed sanukBlack">29.595</span>
                <p>editoras</p>
              </div>
              <div class="numerosBox">
                <span class="ubcRed sanukBlack">3.189</span>
                <p>Intépretes</p>
              </div>
              <div class="numerosBox">
                <span class="ubcRed sanukBlack">712</span>
                <p>músicos</p>
              </div>
              <div class="numerosBox">
                <span class="ubcRed sanukBlack">133</span>
                <p>produtores fonográficos</p>
              </div> -->
            </div>
            <div class="col49sub topMob32">
              <span class="titleDireitos sanukBold">Nacional</span>
              <div class="numerosBox">
                <span class="ubcRed sanukBlack">32.809</span>
                <!-- <p>compositores/autores</p> -->
              </div>
              <!-- <div class="numerosBox">
                <span class="ubcRed sanukBlack">1.100</span>
                <p>editoras</p>
              </div>
              <div class="numerosBox">
                <span class="ubcRed sanukBlack">11.848</span>
                <p>Intépretes</p>
              </div>
              <div class="numerosBox">
                <span class="ubcRed sanukBlack">10.055</span>
                <p>músicos</p>
              </div>
              <div class="numerosBox">
                <span class="ubcRed sanukBlack">6.482</span>
                <p>produtores fonográficos</p>
              </div> -->
            </div>
          </div>
          <div class="col100 top50 boxEnd">
            <p>
              Direitos retidos liberados:
              <span class="ubcRed sanukBlack">R$ 128.956.033,50</span>
            </p>
            <p>
              # Obras cadastradas
              <span class="ubcRed sanukBlack"> 3.054.853</span>
            </p>
            <p>
              # Fonogramas cadastrados
              <span class="ubcRed sanukBlack"> 1.684.164</span>
            </p>
            <p>
              # Cue sheets cadastrados
              <span class="ubcRed sanukBlack"> 21.413</span>
            </p>
            <p>
              # Associados diretos da UBC
              <span class="ubcRed sanukBlack"> 71.027</span>
            </p>
            <p>
              # Funcionários da UBC<span class="ubcRed sanukBlack"> 125</span>
            </p>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { ShareFunctions } from "../assets/js/functions.js";

export default {
  name: "OsNumeros2025",
  props: ["clicked"],

  data() {
    return {
      setaScrollState: false,
    };
  },
  mounted() {
    const conteudo = document.querySelector("#numeros2022");
    conteudo.addEventListener("scroll", ShareFunctions.headerScroll);
  },
  methods: {
    goNext: function () {
      this.$emit("go-next");
    },
    goBack: function () {
      this.$emit("go-back");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.numerosBox {
  margin-top: 12px;
}
.numerosBox p {
  margin: 0;
  font-size: 16px !important;
}
.numerosBox span {
  font-size: 24px;
}
.titleDireitos {
  font-size: 16px;
}
.boxEnd p span {
  font-size: 24px;
}
@media screen and (max-width: 800px) {
  .topMob32 {
    margin-top: 32px;
  }
}
</style>
